import store from '../../../store'

const LenovoData = store.state.lenovoData

export const ABILITY_FILE_MANAGE = 100
export const ABILITY_CUSTOM = 101
export const ABILITY_AD = 102
export const ABILITY_ACCOUNT_SETTING = 103
export const ABILITY_AUTO_FILE = 104
export const ABILITY_SECURITY = 105
export const ABILITY_DLP = 106
export const ABILITY_INTELLIGENCE = 107
export const ABILITY_ACCESS_MANAGE = 108
export const ABILITY_LOG = 109
export const ABILITY_STRATEGY = 110
export const ABILITY_USER_TEAM = 111
export const ABILITY_ADMIN = 112
export const ABILITY_FILE_SETTING = 113
export const ABILITY_FOLDER_TEMPLATE = 114
export const ABILITY_STAT = 115
export const ABILITY_RECYCLE = 116
export const ABILITY_LINK = 117
export const ABILITY_NOTICE = 118
export const ABILITY_WHITERLIST = 119

export const ABILITY_CODE = [
  ABILITY_FILE_MANAGE,
  ABILITY_CUSTOM,
  ABILITY_AD,
  ABILITY_ACCOUNT_SETTING,
  ABILITY_AUTO_FILE,
  ABILITY_SECURITY,
  ABILITY_DLP,
  ABILITY_INTELLIGENCE,
  ABILITY_ACCESS_MANAGE,
  ABILITY_LOG,
  ABILITY_STRATEGY,
  ABILITY_USER_TEAM,
  ABILITY_ADMIN,
  ABILITY_FILE_SETTING,
  ABILITY_FOLDER_TEMPLATE,
  ABILITY_STAT,
  ABILITY_RECYCLE,
  ABILITY_LINK,
  ABILITY_NOTICE,
  ABILITY_WHITERLIST,
]

/**
 * 存放有关权限的所有config数据
 */
const authConfig = {
  // 自定义权限掩码
  G_CUSTOM_AUTH_CODE: {
    preview: 1,
    download: 4,
    upload: 2,
    create: 32,
    delivery: 24,
    delete: 64,
    rename: 128,
    copy: 512,
    move: 256,
    comment: 2048,
    list: 1024,
  },
  // 标准权限掩码
  G_STANDARD_AUTH_CODE: {
    preview: 3073,
    download: 3613,
    upload: 3130,
    uploaddownload: 3647,
    edit: 4095,
    deny: 0,
    list: 1024,
  },
  // 权限名称
  G_AUTH_TITLE: {
    list: 'lenovocloud.auth.list',
    preview: 'lenovocloud.auth.preview',
    upload: 'lenovocloud.auth.upload',
    download: 'lenovocloud.auth.download',
    uploaddownload: 'lenovocloud.auth.uploaddownload',
    edit: 'lenovocloud.auth.edit',
    deny: 'lenovocloud.auth.deny',
    custom: 'lenovocloud.auth.custom',
    create: 'lenovocloud.auth.create',
    delivery: 'lenovocloud.auth.delivery',
    delete: 'lenovocloud.auth.delete',
    rename: 'lenovocloud.auth.rename',
    copy: 'lenovocloud.auth.copy',
    move: 'lenovocloud.auth.move',
    comment: 'lenovocloud.auth.comment',
  },
}

/**
 * 依据权限名称全集生成默认数据
 * @return {Object}
 */

const generaterDefaultData = () => {
  const defaultAuthData = {}
  const commandTitles = Object.keys(authConfig.G_AUTH_TITLE)
  commandTitles.forEach((command) => {
    defaultAuthData[command] = false
  })
  return defaultAuthData
}

/**
 * 依据权限掩码获取CSSAction
 * @param code
 * @return {Array}
 */
const getCSSActionByCodeInner = (code) => {
  const rsArray = Object.keys(authConfig.G_CUSTOM_AUTH_CODE).filter(
    (key) => (code & authConfig.G_CUSTOM_AUTH_CODE[key]) === authConfig.G_CUSTOM_AUTH_CODE[key],
  )
  return rsArray
}

/**
 * 根据CssAction获取新的权限数据
 * @param code
 * @return {Object}
 */
const getAuthDataByCssAction = (code) => {
  const authDataNew = {}
  const cssActions = getCSSActionByCodeInner(code)
  cssActions.forEach((cssAction) => {
    authDataNew[cssAction] = true
  })
  return authDataNew
}

/**
 * 定义权限名称常量
 */
const PREVIEW = 'preview' // 预览
const DOWNLOAD = 'download' // 下载
const UPLOADDOWNLOAD = 'uploaddownload' // 上传/下载
const UPLOAD = 'upload' // 上传
const EDIT = 'edit' // 编辑
const DENY = 'deny' // 禁止访问
const CUSTOM = 'custom' // 自定义
const CREATE = 'create' // 可新建
const DELIVERY = 'delivery' // 可创建外链
const DELETE = 'delete' // 可删除
const RENAME = 'rename' // 可重命名
const COMMENT = 'comment' // 可评论
const MOVE = 'move' // 可移动
const COPY = 'copy' // 可复制
const LIST = 'list' // 可见列表

/**
 * 依据权限编码获取cssAction和权限类型（返回字符串）
 * @param code
 * @returns {authCSS,authType}
 */
export const getCSSActionByCode = (code) => {
  let rs = ''
  const returnData = {}
  Object.keys(authConfig.G_CUSTOM_AUTH_CODE).forEach((o) => {
    if ((code & authConfig.G_CUSTOM_AUTH_CODE[o]) === authConfig.G_CUSTOM_AUTH_CODE[o]) {
      if (rs !== '') {
        rs += `:${o}`
      } else {
        rs = o
      }
    }
  })

  returnData.authCSS = rs

  Object.keys(authConfig.G_STANDARD_AUTH_CODE).forEach((i) => {
    if (code === authConfig.G_STANDARD_AUTH_CODE[i]) {
      returnData.authType = i
    }
    if (!returnData.authType) {
      returnData.authType = 'custom'
    }
  })

  return returnData
}

/**
 * 获取权限数据(文本)
 * @param code
 * @return {Object}
 */
export const getAuthDataByText = (code) => {
  const authobj = getCSSActionByCode(code)
  const authCSS = authobj.authCSS.split(':')
  const authType = authobj.authType.split(':')
  const authCSSText = []
  const authTypeText = []
  authCSS.forEach((item) => {
    authCSSText.push(authConfig.G_AUTH_TITLE[item])
  })
  authType.forEach((item) => {
    authTypeText.push(authConfig.G_AUTH_TITLE[item])
  })
  return {
    authType: authTypeText.join(','),
    authCSS: authCSSText.join(','),
  }
}

/**
 * 获取最终的权限数据
 * @param code
 * @return {Object}
 */
export const getAuthData = (code) => {
  const authData = Object.assign(generaterDefaultData(), getAuthDataByCssAction(code))
  const AUTH_DATA = {
    PREVIEW: authData[PREVIEW],
    DOWNLOAD: authData[DOWNLOAD],
    UPLOADDOWNLOAD: authData[UPLOADDOWNLOAD],
    UPLOAD: authData[UPLOAD],
    EDIT: authData[EDIT],
    DENY: authData[DENY],
    CUSTOM: authData[CUSTOM],
    CREATE: authData[CREATE],
    DELIVERY: authData[DELIVERY],
    DELETE: authData[DELETE],
    RENAME: authData[RENAME],
    COMMENT: authData[COMMENT],
    MOVE: authData[MOVE],
    COPY: authData[COPY],
    LIST: authData[LIST],
  }
  return AUTH_DATA
}

/**
 * 是否为chrome浏览器
* @return {Boolean}
 */
export const isChrome = () => {
  const rChrome = /(chrome)\/([\w.]+)/
  return rChrome.exec(navigator.userAgent.toLowerCase()) || false
}

/**
 * 是否为mac浏览器和客户端
 * @return {Boolean}
 */
export const isMacBrower = () => {
  const brower = navigator.userAgent.toLowerCase()
  return brower.indexOf('macintosh') > -1
}

/**
 * 是否为ie浏览器
 * @return {Boolean}
 */
export const isIe = () => {
  const isIeBrower = !!window.ActiveXObject || 'ActiveXObject' in window
  return isIeBrower
}

/**
 * 是否为图片
 * @param mime
 * @return {Boolean}
 */
export const isImage = (mime) => /\.png|jpeg|jpg|bmp|gif|JPEG|JPG|GIF|BMP|psd|ai|eps/.test(mime)

/**
 * 是否为pdf文件
 * @param mime
 * @return {Boolean}
 */
export const isPdf = (mime) => /\.pct|pdf|pmd/.test(mime)

/**
 * 是否为音视频
 * @param mime
 * @returns {boolean}
 */
export const isVideo = (mime) => /\.avi|f4v|mpg|wma|mp4|flv|wmv|mov|3gp|rmvb|mkv|asf|264|mts|vob|m4v/.test(mime)

/**
 * 是否为视频
 * @param mime
 * @returns {boolean}
 */
export const isAudio = (mime) => /\.mp3|aac|ape|flac|wma|ra|wav|mid|vqf|aif|au|dsp|cmf|cda|mod|iff|m3u|m4a|mpa|aiff|ac3|mur|mp2|amr/.test(mime)

/**
 * lenovoDocs编辑
 * @param mime
 * @returns {boolean}
 */
export const editByLenovoDocs = (mime) => /\.doc|odt|odp|ods|dps|wps|et|ppt|xls|docx|pptx|xlsx/.test(mime)

/**
 * 软航编辑
 * @param mime
 * @returns {boolean}
 */
export const editByNtko = (mime) => /\.doc|dps|wps|et|ppt|xls|docx|pptx|xlsx|pdf/.test(mime)

/**
 * 是否可以预览
 * @param mime
 * @returns {boolean}
 */
export const canPreview = (mime, sysConfig) => {
  // portal未部署cad, 网盘cad文件不可以预览
  if (/\.dwg/.test(mime) && (store.state.lenovoData.LenovoData.accountinfo.cad_switch === 'false' || store.state.lenovoData.LenovoData.accountinfo.delivery_cad_swtich === 'false')) {
    return false
  }
  // 如果custom_preview_type为空则不显示预览按钮
  if (sysConfig && sysConfig.custom_preview_type === '') {
    return false
  }
  // lenovoDocs/owa/sharepoint 文件可以预览
  if (sysConfig && (sysConfig.custom_preview_type === 'sharepoint_owa' || sysConfig.custom_preview_type === 'owa' || sysConfig.custom_preview_type === 'lenovoDocs' || sysConfig.custom_preview_type === 'lenovoDocs_owa') && editByLenovoDocs(mime)) {
    return true
  }
  return JSON.parse(window.store.state.curFileInfo.support_preview)
}

/**
 * 是否可以预览 软航插件_Google外链分享
 * @param mime
 * @param isLink
 * @returns {boolean}
 */
export const canPreviewForNtko = (mime, isLink) => {
  // 外链分享的视频文件 不能预览
  if (isLink && isVideo(mime)) {
    return false
  }
  // 外链分享的音频文件 不能预览
  if (isLink && isAudio(mime)) {
    return false
  }
  // rar 后缀的文件不能预览
  if (/\.rar/.test(mime)) {
    return false
  }
  // bmp|BMP 后缀的图片文件不能浏览
  if (isImage(mime) && /bmp|BMP/.test(mime)) {
    return false
  }
  // ac3/aiff/amr/mid/mp2 后缀的音频文件不能浏览
  if (isAudio(mime) && /\.ac3|aiff|amr|mid|mp2/.test(mime)) {
    return false
  }
  // portal未部署cad, 网盘cad文件不可以预览
  if (/\.dwg/.test(mime) && (LenovoData.user.account_info.cad_switch === 'false' || window.delivery_cad_swtich === 'false')) {
    return false
  }
  // txt 后缀的图片/音频/视频文件可以浏览
  if (isImage(mime) || isVideo(mime) || isAudio(mime) || /\.txt/.test(mime)) {
    return true
  }
  // lenovoDocs/owa/sharepoint 文件可以预览
  if (window.sysConfig
      && (window.sysConfig.custom_preview_type === 'sharepoint_owa'
      || window.sysConfig.custom_preview_type === 'owa'
      || window.sysConfig.custom_preview_type === 'lenovoDocs'
      || window.sysConfig.custom_preview_type === 'lenovoDocs_owa')
      && editByLenovoDocs(mime)
  ) {
    return true
  }
  return /\.doc|wpt|dpt|dps|wps|et|pdf|dwg|ppt|txt|xls|docx|pptx|xlsx|png|jpeg|jpg|gif|JPEG|JPG|GIF|pic|word|excel|mp4|wma|mp3|docx|avi|f4v|mpg|flv|wmv|mov|3gp|rmvb|mkv|asf|264|ts|mts|vob|wav|m4v|ape|flac|aac|psd|ai|eps/.test(mime)
}

// 判断本地编辑与docs编辑共存状态
export const getEditStatus = () => {
  const docsConfig = (window.sysConfig.custom_preview_type.indexOf('lenovoDocs') > -1) && LenovoData.user.user_info.docsLimitEnable
  const localConfig = LenovoData.user.account_info.local_edit_switch
  if (docsConfig && localConfig) {
    // 同时开启
    return 1
  } if (docsConfig) {
    // 开启docs
    return 2
  } if (localConfig) {
    // 开启本地
    return 3
  }
  return 0
}

/**
 * 是否可以本地编辑
 * @param mime
 * @returns {boolean}
 */
export const canLocalEdit = (mime) => {
  if (!(/windows|win32/i.test(navigator.userAgent))) {
    return false
  }
  if (/other\//.test(mime)) {
    return false
  }
  if (/\.docker/.test(mime)) {
    return false
  }
  // 音频/视频/图片 文件不能编辑
  if (isImage(mime) || isVideo(mime) || isAudio(mime)) {
    return false
  }
  // pdf文件不能编辑
  if (isPdf(mime)) {
    return false
  }
  if (getEditStatus() !== 1 && getEditStatus() !== 3) {
    return false
  }
  return /\.doc|dps|wps|et|ppt|xls|docx|pptx|xlsx|txt/.test(mime)
}

/**
 * 是否可以编辑
 * @param mime
 * @returns {boolean}
 */
export const canEdit = (mime) => {
  if (/\.docker/.test(mime)) {
    return false
  }
  // 音频/视频/图片 文件不能编辑
  if (isImage(mime) || isVideo(mime) || isAudio(mime)) {
    return false
  }
  // pdf文件不能编辑
  if (isPdf(mime)) {
    return false
  }
  // docs的编辑方式  lenovoDocs 可以编辑
  if (window.sysConfig.custom_preview_type.indexOf('lenovoDocs') > -1 && editByLenovoDocs(mime)) {
    return true
    // docs的编辑方式  sharepoint(协同) 可以编辑 mac中不能编辑
  } if (window.sysConfig.custom_preview_type.indexOf('sharepoint') > -1 && editByLenovoDocs(mime)) {
    if (isMacBrower()) { // mac中不能编辑
      return false
    }
    return true
    // 软航方式编辑 只能在ie浏览器下编辑，其他浏览器不能编辑
  } if (!isIe()) {
    return false
  }
  return /\.doc|dps|wps|et|ppt|xls|docx|pptx|xlsx/.test(mime)
}

// 以下为Util方法，先暂时放在这里

/**
 * 获取用户id
 * @returns {boolean}
 */
export const getUserID = () => {
  if (LenovoData) {
    return LenovoData.user ? LenovoData.user.user_info.uid : -1
  }
  return -1
}

export const isBusiness = () => (LenovoData && LenovoData.user.user_role & 3) === 3

export const isAdmin = () => isBusiness()

export const haveDirAuth = (data) => isAdmin() || (data && data.authable)

// 是否开启个人云端空间
export const isSelfCloudSpace = () => LenovoData
  && LenovoData.user.account_info.cloud_space
  && LenovoData.user.account_info.cloud_space.cloud_switch
  && LenovoData.user.user_info.use_cloud_quota === 1

// 是否开启企业云端空间
export const isEntCloudSpace = () => LenovoData
  && LenovoData.user.account_info.cloud_space
  && LenovoData.user.account_info.cloud_space.cloud_switch
  && LenovoData.user.user_info.cloud_allow_scan === 1
